import { State } from './selector';
import { areObjectsDeeplyEqual } from '../../util/validator';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} state New state
 * @param {State} oldState Old state
 * @returns {Object} Object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const hasSelectedIdChanged = state.selectedId !== oldState.selectedId;
    const hasRoutersChanged = state.routers && !areObjectsDeeplyEqual(state.routers, oldState.routers);
    const hasAvailableRouterIdsChanged = state.availableRouterIds !== oldState.availableRouterIds;
    const hasDisableBookingChanged = state.disableBooking !== oldState.disableBooking;

    return {
        routerPicker: hasSelectedIdChanged || hasRoutersChanged || hasAvailableRouterIdsChanged,
        verticalList: hasSelectedIdChanged,
        disableBooking: hasDisableBookingChanged,
    };
};
